module.exports = __webpack_public_path__ + "images/dummy-46225dc5d4462111f65829f26773be3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./app/frontend/images/dummy.jpg
// module id = 10
// module chunks = 0